import { Gift } from "lucide-react";

// "X ofertas disponíveis para desbloquear" dentro da sacola lateral. No celular
// é a faixa verde presa no rodapé; aqui é a mesma faixa (mesmas animações de
// chamar atenção e de "explodir" ao clicar), só que dentro do cartão.
// O desbloqueio em si (estado e modal de cupons) continua na página.
// `relative` é obrigatório: o brilho (.coupon-shine-overlay::after) é absolute e,
// sem ele, vazava para fora do cartão (no rodapé quem segura é o `fixed`).
export default function OfertasParaDesbloquear({ quantidade, explodindo, onClick }) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`relative w-full bg-gradient-to-r from-green-500 to-green-600 border-b border-green-700 text-white active:opacity-90 overflow-hidden ${explodindo ? "animate-coupon-burst" : "animate-coupon-attract coupon-shine-overlay"}`}
      aria-label="Desbloquear ofertas"
      data-e2e="sacola-lateral-ofertas"
    >
      <div className="px-3 py-2.5 flex items-center justify-center gap-2 relative">
        <Gift className={`w-4 h-4 shrink-0 ${explodindo ? "animate-coupon-spin" : "animate-coupon-wiggle"}`} />
        <span className="text-[13px] font-bold">
          {quantidade} {quantidade === 1 ? "oferta disponível" : "ofertas disponíveis"} para desbloquear
        </span>
        <span className="text-[11px]">→</span>
        {explodindo && (
          <span className="absolute inset-0 pointer-events-none flex items-center justify-center">
            {[...Array(12)].map((_, i) => (
              <span key={i} className="absolute w-1.5 h-1.5 rounded-full bg-white animate-coupon-particle"
                style={{ "--a": `${i * 30}deg`, animationDelay: `${i * 10}ms` }} />
            ))}
          </span>
        )}
      </div>
    </button>
  );
}
